





















import {Component, Prop, Vue} from "vue-property-decorator";
import TextArea from "@/components/UI/TextArea.vue";
import ThemeVariableStore from "@/store/modules/ThemeVariableStore";
import {CmsApiUtil} from "@/_common/api/utils/cms_api_utils";

@Component({
    components: {
        TextArea
    }
})
export default class NameInputs extends Vue {
    @Prop() private placeholder!: string;
    @Prop() private names!: { [language_code: string]: string };
    @Prop({default:50}) private maxLength!:number;

    get languages(): CMS.Language[] {
        if (!ThemeVariableStore.all.value)
            return [];

        return ThemeVariableStore.all.value.languages;
    }

    private getName(languageCode: string): string {
        return CmsApiUtil.getName(this.names, languageCode)
    }
}
